module.exports = __webpack_public_path__ + "img/logo.e9e2bb1d.png";